var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle, _path46, _circle2, _circle3, _path47, _circle4, _path48, _path49, _path50, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouseGrafik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616 326",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.222 171.92H488v149.229H47.222z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.222 115.695h254.662v205.453H47.222z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M47.221 115.695h125.678v205.453H47.221z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M353.788 171.92H496v149.229H353.788z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M40.605 171.92h205.054v112.449H40.605z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M363.711 185.148h122.37v136h-122.37z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M320 289.489a.83.83 0 0 0-.826-.827h-62.347a.829.829 0 0 0-.827.827V301.891h64V289.489z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M301.884 171.92H496v6.614H301.884z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M301.884 36.246H102.756l-55.534 79.376h254.662z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M257.235 9.787h9.922v26.458h-9.922z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M254.755 0h14.883v13.229h-14.883z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M339.844 250.896a.4.4 0 0 1-.4.4H320.4a.4.4 0 0 1-.4-.4v-22.351a.4.4 0 0 1 .4-.4h19.043a.4.4 0 0 1 .4.4v22.351z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M323.308 231.451h13.229v3.309h-13.229z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M323.308 231.451h13.229v1.654h-13.229z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M328 302.719c0-.455-.486-.827-1.082-.827h-77.836c-.596 0-1.082.372-1.082.827V322.135h80V302.719z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#656565",
    d: "M367.018 188.382h115.757v6.614H367.018zM367.018 198.379h115.757v6.613H367.018zM367.018 208.301h115.757v6.614H367.018z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F1",
    d: "M262.971 186.135h49.61v102.527h-49.61zM40.605 181.768h195.132v89.298H40.605z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFC",
    d: "M73.679 181.842 43.913 271.14h36.38l29.766-89.298zM83.601 271.14l29.765-89.298h3.308L86.908 271.14z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M301.884 29.705h165.365V171.92H301.884z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#35322F",
    d: "M298.576 23.017h171.98v6.614h-171.98z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF8FE",
    d: "M315.113 42.934h138.923v129H315.113z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F1",
    d: "M315.113 42.934h138.923v129H315.113z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFC",
    d: "M315.113 125.91v46.024h19.883l46.31-129H344.9zM384.575 42.934l-46.307 129h3.307l46.308-129z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M292.202 43.904v64.177H63.61l44.903-64.177h183.689m1-1h-185.21L61.69 109.081h231.512V42.904z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#003A59",
    d: "M62.65 105.176 108.252 40h184.45v65.176z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M292.202 40.5v64.176H63.61L108.513 40.5h183.689m1-1h-185.21L61.69 105.676h231.512V39.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#CCC",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.763 105.098 39.688-64.982M127.836 105.098l33.073-64.982M160.909 105.098l26.459-64.982M193.982 105.098l19.845-64.982M227.056 105.098l13.229-64.982M260.129 105.098l6.615-64.982"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#CCC",
    strokeMiterlimit: 10,
    d: "M293.202 53.655H98.803M293.202 69.416H87.779M293.202 86.752H75.599"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M61.689 105.67h.827v3.411h-.827zM94.645 105.67h.827v3.411h-.827zM127.6 105.67h.827v3.411h-.827zM160.555 105.67h.827v3.411h-.827zM193.511 105.67h.827v3.411h-.827zM226.466 105.67h.827v3.411h-.827zM259.421 105.67h.827v3.411h-.827zM292.377 105.67h.826v3.411h-.826z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M504.406 166.379c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.615c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.615zM504.406 116.695c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.615c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.615zM504.406 126.617c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.615c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.615zM504.406 136.539c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.615c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.615zM504.406 146.461c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.614c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.614zM504.406 156.383c0-.55-.45-1-1-1H302.884c-.55 0-1 .45-1 1v4.614c0 .55.45 1 1 1h200.522c.55 0 1-.45 1-1v-4.614z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 314.135h616v12H0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M572.219 265.174c-14.35-7.153-32.022-12.247-51.547-15.736-25.197-26.689-56.408-26.287-56.408-26.287-22.684 0-42.432 7.864-52.863 20.337-.873.055-1.748-.018-2.583-.018h-29.071c-1.643 0-1.748.597-1.748 2.234v33.785c0 13.126 9.416 24.443 22.542 24.443h110.148l46.771-1.562 1.945-.16c6.046-.639 10.59-1.419 13.681-1.925 3.24-.534 4.461-2.662 4.461-5.943v-23.761c-.001-3.282-2.392-3.945-5.328-5.407z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE94C",
    d: "M572.219 265.174c-14.35-7.153-32.022-12.247-51.547-15.736-25.197-26.689-56.408-26.287-56.408-26.287-22.684 0-42.432 7.864-52.863 20.337-.873.055-1.748-.018-2.583-.018h-29.071c-1.643 0-1.748.597-1.748 2.234v33.785c0 13.126 9.416 24.443 22.542 24.443H403.721v-10.63c0-12.919 10.473-23.385 23.389-23.385 12.911 0 23.38 10.466 23.38 23.385v10.63h60.199v-10.63c0-12.919 10.474-23.385 23.389-23.385 12.913 0 23.382 10.466 23.382 23.385v9.067l1.945-.16c6.046-.639 10.59-1.419 13.681-1.925 3.24-.534 4.461-2.662 4.461-5.943V270.58c-.001-3.281-2.392-3.944-5.328-5.406z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#002D45",
    d: "M414.477 244.322c4.816-5.35 11.629-9.831 19.801-13.004 8.923-3.467 19.29-5.297 29.986-5.297h.04l.041-.002c1.216.002 29.589.283 53.063 24.17-11.098 2.301-49.716 8.277-102.931-5.867z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M577.546 270.581v23.761c0 3.281-1.221 5.409-4.461 5.943-3.091.506-7.635 1.286-13.681 1.925l-1.945.16v-9.067c0-12.919-10.469-23.385-23.382-23.385-12.915 0-23.389 10.466-23.389 23.385v10.63H450.489v-10.63c0-12.919-10.469-23.385-23.38-23.385-12.916 0-23.389 10.466-23.389 23.385v10.63H400.54c-13.126 0-22.542-11.317-22.542-24.443v-33.785c0-.104.002-.188.006-.284 33.082 8.861 94.514 19.95 197.398 21.371 1.297.817 2.144 1.841 2.144 3.789z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#003A59",
    d: "M464.264 226.021h.04l.041-.002c1.216.002 29.589.283 53.063 24.17-6.627 1.373-23.08 4.047-46.581 2.972-2.057-12.314-6.002-23.023-7.634-27.128.356-.006.712-.012 1.071-.012z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#003A59",
    d: "M462.376 226.041c.272-.005.544-.005.816-.008 1.632 4.104 5.577 14.813 7.634 27.128-12.983-.593-28.113-2.329-44.944-6.066.087-.171 8.488-16.632 36.494-21.054z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC66",
    d: "M470.826 253.161c23.501 1.075 39.954-1.599 46.581-2.972l-.137 20.229c-6.142 4.212-10.171 11.28-10.171 19.292v9.429h-33.887c-.059-7.709-.408-34.108-2.379-45.938l-.007-.04z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC66",
    d: "M425.882 247.095c16.831 3.737 31.961 5.474 44.944 6.066a.707.707 0 0 0 .008.04c1.971 11.83 2.32 38.229 2.379 45.938h-15.062l-4.069-6.562v-2.866c0-10.121-6.425-18.735-15.418-21.991l-12.788-20.617.006-.008z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFE633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.1 289.711v9.429h-33.887c-.047-6.244-.286-24.759-1.423-37.854 13.812 1.382 28.951 2.582 45.519 3.518l-.038 5.615c-6.142 4.212-10.171 11.28-10.171 19.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.213 299.14h-15.062l-4.069-6.562v-2.866c0-10.121-6.425-18.735-15.418-21.991l-7.101-11.448c11.932 1.814 25.303 3.52 40.227 5.015 1.137 13.093 1.376 31.608 1.423 37.852z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M384.494 253.922h.509c.201 0 .392.083.529.233l7.894 8.61a.718.718 0 0 1-.531 1.201h-8.4c.587-1.564.922-3.253.922-5.021a14.282 14.282 0 0 0-.923-5.023z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#A70000",
    d: "M380.869 253.922h3.625c.587 1.565.922 3.252.922 5.023 0 1.769-.335 3.457-.922 5.021h-3.625v-10.044z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5FFFF",
    d: "M556.768 265.893a.716.716 0 0 1 .68-.486h6.489a17.01 17.01 0 0 0 5.779 8.61h-2.938a.72.72 0 0 1-.436-.15l-9.331-7.172a.72.72 0 0 1-.243-.802z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M563.937 265.406h2.02c1.716.758 3.379 1.536 4.983 2.335.387.194.766.374 1.129.549 2.605 1.236 2.605 1.418 2.605 2.291v3.436h-4.958a17.01 17.01 0 0 1-5.779-8.611z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M425.882 247.095c.087-.171 8.488-16.632 36.494-21.054.272-.005.544-.005.816-.008 1.632 4.104 5.577 14.813 7.634 27.128"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m517.407 250.189-.137 20.229c-6.142 4.212-10.171 11.28-10.171 19.292v9.429h-33.887c-.059-7.709-.408-34.108-2.379-45.938a.707.707 0 0 1-.008-.04"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M470.826 253.161a.707.707 0 0 0 .008.04c1.971 11.83 2.32 38.229 2.379 45.938h-15.062l-4.069-6.562v-2.866c0-10.121-6.425-18.735-15.418-21.991l-12.788-20.617.006-.008M463.192 226.033a63.5 63.5 0 0 1 1.071-.012h.04l.041-.002c1.216.002 29.589.283 53.063 24.17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 534.05,
    cy: 293.303,
    r: 20.832
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M406.251 293.303c0 11.503 9.329 20.832 20.835 20.832 11.505 0 20.828-9.329 20.828-20.832 0-11.508-9.323-20.831-20.828-20.831-11.506 0-20.835 9.323-20.835 20.831z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 534.05,
    cy: 293.303,
    r: 17.148
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "gray",
    cx: 534.05,
    cy: 293.303,
    r: 8
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M409.934 293.303c0 9.47 7.68 17.148 17.152 17.148 9.469 0 17.145-7.679 17.145-17.148 0-9.472-7.676-17.148-17.145-17.148-9.473-.001-17.152 7.676-17.152 17.148z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "gray",
    cx: 427.082,
    cy: 293.303,
    r: 8
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M368.672 238.066h-4.961v36.068h4.961c.909 0 1.653-.744 1.653-1.653V239.72c0-.909-.744-1.654-1.653-1.654z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M372.323 243.027c14.469-1.653 6.457 17.835 3.037 27.079-3.824 10.335-11.063 32.738-2.142 29.766 13.643-4.548-29.219-41.737 23.614-37.905"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M371.979 241.374h-1.653v3.307h1.653a1.654 1.654 0 0 0 0-3.307z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.833,
    cy: 261.967,
    r: 2
  })));
}

export default SvgHouseGrafik;